import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import * as api from '../../lib/api';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import ButtonSpinner from '../../components/ui/ButtonSpinner';

export const AdvisorNotes = ({ docId, initialNotes }) => {
  const { user } = useAuth();
  const [notes, setNotes] = useState(initialNotes);
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);

  useEffect(() => { setNotes(initialNotes); }, [initialNotes]);

  const handleSave = async () => {
    setSaving(true);
    setSaveError(null);
    try {
      await api.saveAdvisorNote(docId, user.id, notes);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      console.error(err);
      setSaveError('Could not save notes. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="p-2 bg-amber-50 rounded-lg">
            <SafeIcon icon={FiIcons.FiClipboard} className="text-amber-600" />
          </div>
          <div>
            <h3 className="font-semibold text-brand-navy">Advisor Notes</h3>
            <p className="text-xs text-slate-500">Internal notes — not visible to the client</p>
          </div>
        </div>
        {saved && (
          <span className="flex items-center gap-1.5 text-emerald-600 text-sm font-medium">
            <SafeIcon icon={FiIcons.FiCheck} /> Saved
          </span>
        )}
      </div>
      <textarea
        className="w-full min-h-[140px] px-4 py-3 border border-slate-300 rounded-lg resize-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 outline-none transition-colors text-sm text-slate-700 placeholder:text-slate-400"
        placeholder="Add internal notes about this document or client..."
        value={notes}
        onChange={(e) => { setNotes(e.target.value); setSaved(false); }}
        disabled={saving}
      />
      {saveError && (
        <p className="text-sm text-red-600 mb-2">{saveError}</p>
      )}
      <div className="flex justify-between items-center mt-3">
        <p className="text-xs text-slate-400">{notes.length} characters</p>
        <button
          onClick={handleSave}
          disabled={saving || !notes.trim()}
          className="btn-primary text-sm py-1.5 min-w-[110px]"
        >
          {saving ? (
            <>
              <ButtonSpinner />
              Saving...
            </>
          ) : (
            <>
              <SafeIcon icon={FiIcons.FiSave} /> Save Notes
            </>
          )}
        </button>
      </div>
    </div>
  );
};